
import { React, useRef, useState } from 'react';

const TYPING_RATE = 40;

const title = 'Dudo Perudo';

const description = 'an ai-integrated, web-based version of Perudo';

const DudoPerudoGif = () => {

    const [showTitle, setShowTitle] = useState('');
    const [showDescription, setShowDescription] = useState('');

    const timeoutIds = useRef([]);

    const handleMouseEnter = () => {

        let delay = 0;

        // Clear any existing timeouts
        timeoutIds.current.forEach(timeoutId => clearTimeout(timeoutId));
        timeoutIds.current = [];

        // Iterate through the title string
        for (const char of title) {
            const timeoutId = setTimeout(() => {
                setShowTitle((prev) => prev + char);
            }, delay);
            timeoutIds.current.push(timeoutId);
            delay += TYPING_RATE;
        }

        // Iterate through the description string
        for (const char of description) {
            const timeoutId = setTimeout(() => {
                setShowDescription((prev) => prev + char);
            }, delay);
            timeoutIds.current.push(timeoutId);
            delay += TYPING_RATE;
        }
    };

    const handleMouseLeave = () => {
        // Clear any existing timeouts
        timeoutIds.current.forEach(timeoutId => clearTimeout(timeoutId));
        timeoutIds.current = [];
        setShowTitle('');
        setShowDescription('');
    };


    return (
        <a 
        className='game'
        href='https://dudoperudo.com' target='_blank' rel='noreferrer'>
            <div className='image-container'
            onMouseEnter={() => {
                handleMouseEnter()
            }}
            onMouseLeave={() => {
                handleMouseLeave()
            }}
            >


                <img 
                src='/assets/dudoperudo.gif' 
                alt='crash' 
                className='hover-gif dudo-perudo-gif'
                />

                <div className='overlay-text'
                style={{width: '80%',
                }}>

                    <h2>
                        {showTitle}
                    </h2>
                    <p
                    >
                        {showDescription}
                    </p>                    
                    
                </div>

            </div>
        </a>
    )


};


export default DudoPerudoGif;